import React, { useEffect, useState, Fragment } from "react";
import uploadImage from "../../assets/images/Home-Banner.svg";
import commentmodel from "../../assets/images/comment-model.jpg";
import profileavtar from "../../assets/images/profileavtar.png";
import scrollIcon from "../../assets/images/scroll-down.png";
import { Drawer, Badge as AntdBadge } from "antd";
import {
  Badge,
  Button,
  Card,
  Col,
  Form,
  Row,
  Image,
  Modal,
  Container,
} from "react-bootstrap";
import MasterLayout from "../../components/Layout/MasterLayout";
import { useDispatch, useSelector } from "react-redux";
import {
  addOfferCandidateComment,
  offerCandidateCommentListing,
  offerdocumentsRequestDocList,
  offerdocumentFileUpload,
  offerdocumentFileUploadEdit,
} from "./actions";
import moment from "moment";
import { getItem, timeAgo } from "../../utils/Functions";
import DocumentPreview from "../../components/DocumentPreview";
import UploadDocument from "./UploadDocument";
import { offeredCandidateProfile } from "../Profile/actions";
import { Typewriter } from "react-simple-typewriter";
import { scrollTo } from "../../components/AnimateScroll/scrollTo";

const Documents = () => {
  const dispatch = useDispatch();
  let candidateProfileId = JSON.parse(getItem("User"))._id;
  const addCommentReduxData = useSelector(
    (state) => state.document.addOfferDiscussionComment
  );
  const commentListReduxData = useSelector(
    (state) => state.document.offerCommentListing
  );
  const documentRequestDocReduxListData = useSelector(
    (state) => state.document.offerdocumentsSendRequestDoc
  );
  const fileUploadReduxData = useSelector(
    (state) => state.document.offerdocumentsFileUpload
  );
  const fileDeleteRedux = useSelector(
    (state) => state.document.offerdocumentsFileUploadEdit
  );
  const offeredCandidateReduxData = useSelector(
    (state) => state.profile.OfferedCandidateProfileDetails
  );
  var [errors, setErrors] = useState({ comment: "" });
  const [docummentComment, setDocummentComment] = useState("");
  const [discussionCommentList, setDiscussionCommentList] = useState([]);
  const [requestDocList, setRequestDocList] = useState([]);
  const [s3bucketUrl, setS3BucketUrl] = useState();
  const [docPreviewData, setDocPreviewData] = useState({
    filePath: "",
    urlType: "",
  });
  const [currentSelctedIDX, setCurrentSelctedIDX] = useState("");
  const [isImgEditorShown, setIsImgEditorShown] = useState(false);
  const [base64, setBase64] = useState("");
  const [imageFile, setImageFile] = useState({ FileName: {} });
  const [payload, setPayload] = useState({
    id: "",
    submittedBy: "candidate",
    file: "",
    givenDocName: "",
  });
  const [discussionCommentId, setDiscussionCommentId] = useState({
    docId: "",
    candidateId: "",
    docPath: "",
  });
  const [toggle, setToggle] = useState(false);
  const [currentDiscussion, setCurrentDiscussion] = useState();
  const [modalShow, setModalShow] = useState(false);
  const [commentData, setCommentData] = useState("");
  const [offerProfileData, setProfileCandidateData] = useState({
    _id: "",
    candidateId: "",
    portalId: "",
    firstName: "",
    lastName: "",
    mobile: "",
    emailId: "",
    portalCreatedAt: "",
    photo: null,
    candidateStatus: "",
    invitedOn: true,
    addedBy: {
      _id: "",
      firstName: "",
      lastName: "",
    },
    modifiedBy: {
      _id: "",
      firstName: "",
      lastName: "",
    },
    isActive: true,
    createdAt: "",
  });

  useEffect(() => {
    dispatch(offeredCandidateProfile(candidateProfileId));
  }, [candidateProfileId]);
  useEffect(() => {
    if (
      documentRequestDocReduxListData &&
      documentRequestDocReduxListData.status > 0
    ) {
      const data = documentRequestDocReduxListData?.data?.data.map((item) => {
        item["fileError"] = "";
        item["fileErrorClass"] = "";
        item["givenDocNameError"] = "";
        item["givenDocNameErrorClass"] = "";
        item["file"] = "";
        item["givenDocName"] = "";
        item["base64"] = "";
        item["uploadedDocName"] = "";
        item["isDisable"] = true;
        item["isReupload"] = false;
        item["isActionShow"] = false;
        return item;
      });
      setRequestDocList(data);
      setS3BucketUrl(documentRequestDocReduxListData?.data?.filePath);
    }
  }, [documentRequestDocReduxListData]);

  useEffect(() => {
    if (commentListReduxData && commentListReduxData.status > 0) {
      setDiscussionCommentList(commentListReduxData.data);
    }
  }, [commentListReduxData]);

  useEffect(() => {
    if (fileUploadReduxData && fileUploadReduxData.status > 0) {
      setBase64("");
      dispatch(
        offerdocumentsRequestDocList({
          candidateId: JSON.parse(getItem("User"))?._id,
          requestedBy: JSON.parse(getItem("User"))?._id,
        })
      );
    }
  }, [fileUploadReduxData]);

  useEffect(() => {
    dispatch(
      offerdocumentsRequestDocList({
        candidateId: JSON.parse(getItem("User"))?._id,
        requestedBy: JSON.parse(getItem("User"))?._id,
      })
    );
  }, [addCommentReduxData]);

  useEffect(() => {
    if (addCommentReduxData && addCommentReduxData.status > 0) {
      dispatch(
        offerdocumentsRequestDocList({
          candidateId: JSON.parse(getItem("User"))?._id,
          requestedBy: JSON.parse(getItem("User"))?._id,
        })
      );
      getDiscussionCommentList(currentDiscussion);
    }
  }, [addCommentReduxData]);
  useEffect(() => {
    if (fileDeleteRedux && fileDeleteRedux.status > 0) {
      dispatch(
        offerdocumentsRequestDocList({
          candidateId: JSON.parse(getItem("User"))?._id,
          requestedBy: JSON.parse(getItem("User"))?._id,
        })
      );
    }
  }, [fileDeleteRedux]);

  useEffect(() => {
    if (offeredCandidateReduxData && offeredCandidateReduxData.status > 0) {
      setProfileCandidateData(offeredCandidateReduxData.data);
    }
  }, [offeredCandidateReduxData]);
  /******************* 
@Purpose : Used to Handle error 
@Parameter :()
@Author : INIC
******************/
  const addDefaultSrc = (ev) => {
    ev.target.src = profileavtar;
  };

  /******************* 
@Purpose : Used to close the image editor
@Parameter :()
@Author : INIC
******************/
  const closeImgEditor = () => {
    setIsImgEditorShown(false);
  };
  const openImgEditor = () => {
    // setIsImgEditorShown(true);
  };
  /******************* 
@Purpose : Used to handle the type
@Parameter :()
@Author : INIC
******************/
  const handleTypeStatus = (status, idx) => {
    const dublicateDoc = [...requestDocList];
    dublicateDoc[idx]["givenDocName"] = status;
    dublicateDoc[idx]["givenDocNameError"] = "";
    dublicateDoc[idx]["givenDocNameErrorClass"] = "";
    dublicateDoc[idx]["isDisable"] = false;
    setRequestDocList(dublicateDoc);
    setCurrentSelctedIDX(idx);
  };
  /******************* 
@Purpose : Used to reupload 
@Parameter :(status,idx)
@Author : INIC
******************/
  const handleReUpload = (status, idx) => {
    const dublicateDoc = [...requestDocList];
    dublicateDoc[idx]["isReupload"] = status;
    setRequestDocList(dublicateDoc);
  };

  const handleActions = (action, idx) => {
    const dublicateDoc = [...requestDocList];
    dublicateDoc[idx]["isActionShow"] = action;
    setRequestDocList(dublicateDoc);
  };
  /******************* 
@Purpose : Used to delete the file
@Parameter :(item)
@Author : INIC
******************/
  const handleDocDelete = async (item) => {
    const payload = {
      id: item._id,
      type: "docPath",
      filePath: item.docPath,
    };
    await dispatch(offerdocumentFileUploadEdit(payload));
  };
  /******************* 
@Purpose : Used get the image
@Parameter :(file, idx)
@Author : INIC
******************/
  const handleChange = async (file, idx) => {
    let dublicateDoc = [...requestDocList];
    const list = { ...imageFile };
    list["FileName"] = file;
    setCurrentSelctedIDX(idx);
    if (file.type === "application/pdf") {
      setIsImgEditorShown(false);
      dublicateDoc[idx]["file"] = list;
      dublicateDoc[idx]["fileError"] = "";
      dublicateDoc[idx]["fileErrorClass"] = "";
      dublicateDoc[idx]["uploadedDocName"] = file.name;
      dublicateDoc[idx]["isDisable"] = false;
      setRequestDocList(dublicateDoc);
    } else if (file.imageBase64) {
      dublicateDoc[idx]["base64"] = file.imageBase64;
      dublicateDoc[idx]["fileError"] = "";
      dublicateDoc[idx]["fileErrorClass"] = "";
      dublicateDoc[idx]["isDisable"] = false;
      setRequestDocList(dublicateDoc);
    } else {
      dublicateDoc[idx]["uploadedDocName"] = file.name;
      setRequestDocList(dublicateDoc);
      setImageFile(URL.createObjectURL(file));
      setIsImgEditorShown(true);
    }
  };
  /******************* 
@Purpose : Used to handle the Badge status
@Parameter :(item)
@Author : INIC
******************/
  const documentStatus = (item) => {
    return (
      <Badge
        variant={
          item?.status === "Accepted"
            ? "success"
            : item?.status === "In-Review"
            ? "warning"
            : item?.status === "Declined" && "danger"
        }
        bg={
          item?.status === "Accepted"
            ? "success"
            : item?.status === "In-Review"
            ? "warning"
            : item?.status === "Decline" && "danger"
        }
      >
        {item && item.status}
      </Badge>
    );
  };
  const sendDocumentValidation = (id, idx) => {
    let isValid = true;
    let fileUploadForm = [...requestDocList];
    const resultData = fileUploadForm.find((item, index) => item._id === id);
    if (!resultData["base64"] && !resultData["file"]) {
      fileUploadForm[idx]["fileError"] = "Please upload a Document";
      fileUploadForm[idx]["fileErrorClass"] = "error-red";
      isValid = false;
    }
    if (!resultData["givenDocName"]) {
      fileUploadForm[idx]["givenDocNameError"] = "Please select a Document Type";
      fileUploadForm[idx]["givenDocNameErrorClass"] = "error-red";
      isValid = false;
    }
    setRequestDocList(fileUploadForm);
    return isValid;
  };

  const sendUploadDocument = async (id, idx) => {
    if (sendDocumentValidation(id, idx)) {
      if (requestDocList[idx]["base64"] === "") {
        let formData = new FormData();
        formData.append("id", id);
        formData.append("file", requestDocList[idx].file["FileName"]);
        formData.append("submittedBy", "candidate");
        formData.append("givenDocName", requestDocList[idx]["givenDocName"]);
        await dispatch(offerdocumentFileUpload(formData));
      } else if (requestDocList[idx]["base64"]) {
        fetch(requestDocList[idx]["base64"])
          .then((res) => res.blob())
          .then((blob) => {
            const fd = new FormData();
            const file = new File(
              [blob],
              requestDocList[idx]["uploadedDocName"]
            );
            fd.append("id", id);
            fd.append("file", file);
            fd.append("submittedBy", "candidate");
            fd.append("givenDocName", requestDocList[idx]["givenDocName"]);
            dispatch(offerdocumentFileUpload(fd));
          });
      } else {
        let payload = new FormData();
        payload.append("id", id);
        payload.append("file", requestDocList[idx].file["FileName"]);
        payload.append("submittedBy", "candidate");
        payload.append("givenDocName", requestDocList[idx]["givenDocName"]);
        await dispatch(offerdocumentFileUpload(payload));
      }
    }
  };

  /******************* 
@Purpose : Used to add the comment 
@Parameter :e
@Author : INIC
******************/
  const addComment = async (e) => {
    e.preventDefault();
    if (
      docummentComment !== "" &&
      docummentComment !== undefined &&
      docummentComment.replace(/^\s+/g, "")
    ) {
      const body = {
        msg: docummentComment,
        documentId: discussionCommentId.docId,
        candidateId: discussionCommentId.candidateId,
      };
      await dispatch(addOfferCandidateComment(body));
      // getdata by id api
      setDocummentComment("");
      // handleClose();
    } else {
      setErrors({ comment: "Please enter your comment" });
    }
  };
  /******************* 
@Purpose : Used to get the discuession list  
@Parameter :(item)
@Author : INIC
******************/
  const getDiscussionCommentList = async (item) => {
    setCurrentDiscussion(item);
    await dispatch(
      offerCandidateCommentListing({
        candidateId: JSON.parse(getItem("User"))._id,
        docId: item._id ? item._id : "",
      })
    );
    setDiscussionCommentId({
      docId: item._id,
      candidateId: JSON.parse(getItem("User"))._id,
      docPath: item.docPath,
    });
  };
  /******************* 
@Purpose : Used to handle modal
@Parameter :()
@Author : INIC
******************/
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = (item) => {
    setOpen(true);
    setCommentData(item);
  };

  /******************* 
@Purpose : Used to handle scroll
@Parameter :()
@Author : INIC
******************/
  const handleScroll = () => {
    document.getElementById("uploadBtn");
    scrollTo({ id: "upload-document" });
  };

  /******************* 
@Purpose : Ant-Drawer for comment modal
@Parameter :
@Author : INIC
******************/
  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  const docs = [
    {
      uri: docPreviewData.filePath,
    },
  ];

  return (
    <>
      <MasterLayout>
        <section className="home-banner-wrap">
          <Container>
            <Row>
              <Col sm={6} className="my-auto">
                <h5 className="banner-sub-caption">
                  Welcome to Candidate Portal
                </h5>
                <h1 className="banner-main-caption">
                  Upload your{" "}
                  <strong>
                    <Typewriter
                      words={["Documents..."]}
                      loop={1}
                      typeSpeed={130}
                      deleteSpeed={50}
                      delaySpeed={1000}
                    />
                  </strong>
                </h1>
                <Button
                  variant="primary"
                  id="uploadBtn"
                  className="btn-upload"
                  onClick={() => handleScroll()}
                >
                  Upload here <span className="bx bxs-chevron-down"></span>
                </Button>
              </Col>
              <Col sm={6}>
                <div className="banner-img">
                  <Image src={uploadImage} alt="Upload Image" />
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <div
          id="mouse_scroll"
          className="mouse_arrow"
          onClick={() => handleScroll()}
        >
          <a className="mouse_icon d-flex" title="Scroll Down">
            <Image
              src={scrollIcon}
              alt="Scroll Down Icon"
              className="scroll-icon"
            />
          </a>
        </div>
        <section>
          <Container>
            <div className="upload-documents" id="upload-document">
              <div className="section-title">
                <h1 className="title">My Documents</h1>
                <span className="divider"></span>
                <p className="sub-title">
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry.
                  <br />
                  When an unknown printer took a galley of type and scrambled it
                  to make a type specimen book.
                </p>
              </div>
              <div className="file-uploader panel-content">
                {documentRequestDocReduxListData &&
                  documentRequestDocReduxListData?.data &&
                  documentRequestDocReduxListData?.data?.data?.map(
                    (item, index) => {
                      return !item.docPath || item.isReupload ? (
                        <Form.Group key={index}>
                          <UploadDocument
                            item={item}
                            index={index}
                            handleChange={handleChange}
                            handleTypeStatus={handleTypeStatus}
                            sendUploadDocument={sendUploadDocument}
                            payload={payload}
                            isImgEditorShown={isImgEditorShown}
                            imageFile={imageFile}
                            closeImgEditor={closeImgEditor}
                            setBase64={setBase64}
                            currentSelctedIDX={currentSelctedIDX}
                          />
                        </Form.Group>
                      ) : null;
                    }
                  )}
              </div>
            </div>
            <div className="upload-documents uploaded-documents">
              <div className="section-title">
                <h2 className="title">Uploaded Documents</h2>
                <span className="divider"></span>
              </div>
              <div className="panel-content">
                <div className="document-uploaded-wrapper">
                  <Row>
                    {documentRequestDocReduxListData &&
                      documentRequestDocReduxListData?.data &&
                      documentRequestDocReduxListData?.data?.data?.map(
                        (item, index) => {
                          const urlData =
                            item && item.docPath && item?.docPath?.split(".");
                          const url =
                            item && item.docPath && item?.docPath?.split("/");
                          const urlType =
                            urlData === undefined ? null : urlData[1];
                          const filePathName = url?.slice(-1)[0];
                          return (
                            item.docPath && (
                              <Col lg={4} md={6} className="mb-4">
                                <Card
                                  className={
                                    item.status === "Decline" &&
                                    "document-rejected"
                                  }
                                >
                                  <Card.Header className="p-0">
                                    <div className="document-preview-container">
                                      {urlType === "pdf" && (
                                        <object
                                          data={s3bucketUrl + item.docPath}
                                          type="application/pdf"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                          }}
                                        />
                                      )}
                                      {urlType === "jpeg" && (
                                        <Card.Img
                                          variant="top"
                                          src={s3bucketUrl + item.docPath}
                                          alt="Document Image"
                                        />
                                      )}
                                      {urlType === "jpg" && (
                                        <Card.Img
                                          variant="top"
                                          src={s3bucketUrl + item.docPath}
                                          alt="Document Image"
                                        />
                                      )}
                                      {urlType === "png" && (
                                        <Card.Img
                                          variant="top"
                                          src={s3bucketUrl + item.docPath}
                                          alt="Document Image"
                                        />
                                      )}
                                    </div>
                                    <div className="change-options">
                                      <input
                                        type="checkbox"
                                        id={`AddressProof${index}`}
                                        className="change-toggle"
                                        onClick={() => {
                                          handleActions(true, index);
                                        }}
                                      ></input>
                                      <label
                                        title="Click Here"
                                        htmlFor={`AddressProof${index}`}
                                        className="change-button"
                                      >
                                        <span className="bx bx-plus-circle"></span>
                                      </label>

                                      <a
                                        title="Re-upload"
                                        onClick={() =>
                                          handleReUpload(true, index)
                                        }
                                        className="change-icon"
                                      >
                                        <span
                                          className="bx bx-upload"
                                          title="Re-Upload"
                                        ></span>
                                      </a>
                                      {item &&
                                      item?.status === "Accepted" ? null : (
                                        <a
                                          title="Delete"
                                          onClick={() => handleDocDelete(item)}
                                          className="change-icon"
                                        >
                                          <span
                                            className="bx bx-trash"
                                            title="Delete"
                                          ></span>
                                        </a>
                                      )}
                                      <a
                                        title="Preview"
                                        onClick={() => {
                                          setModalShow(true);
                                          setDocPreviewData({
                                            filePath:
                                              s3bucketUrl + item.docPath,
                                            urlType: urlType,
                                          });
                                        }}
                                        className="change-icon"
                                      >
                                        <span className="bx bx-show"></span>
                                      </a>
                                    </div>
                                  </Card.Header>
                                  <Card.Body className="p-0">
                                    <div className="">
                                      <div className="section-title-heading flex-grow-1 mt-4 mb-2">
                                        <div className="doc-title w-75">
                                          <h5 className="doc-name font-weight-medium text-truncate mb-0">
                                            {item.docName}
                                          </h5>
                                          <span className="divider"></span>
                                        </div>
                                        <div>
                                          <AntdBadge
                                            count={
                                              item &&
                                              item.candidateUnSeenDiscussion
                                                .length
                                            }
                                          >
                                            <Button
                                              variant="dark"
                                              title="Comments"
                                              onClick={() => {
                                                handleShow(item);
                                                getDiscussionCommentList(item);
                                                setDocPreviewData({
                                                  filePath:
                                                    s3bucketUrl + item.docPath,
                                                  urlType: urlType,
                                                });
                                              }}
                                            >
                                              <span className="bx bx-message-rounded-dots"></span>{" "}
                                            </Button>
                                          </AntdBadge>
                                        </div>
                                      </div>
                                      <div className="d-flex align-items-center justify-content-between flex-grow-0 flex-shrink-0 flex-width-auto mb-3">
                                        <Badge className="bg-secondary">
                                          {item &&
                                            item.updatedAt &&
                                            timeAgo(item.updatedAt)}
                                        </Badge>
                                        {documentStatus(item)}
                                      </div>
                                      <Card.Text className="text-truncate">
                                        {item.givenDocName}
                                      </Card.Text>
                                      <span className="file-details text-truncate">
                                        {item.originalPath}
                                      </span>
                                    </div>
                                  </Card.Body>
                                </Card>
                              </Col>
                            )
                          );
                        }
                      )}
                    {modalShow && (
                      <DocumentPreview
                        setModalShow={setModalShow}
                        modalShow={modalShow}
                        docs={docs}
                      />
                    )}
                    {documentRequestDocReduxListData &&
                    documentRequestDocReduxListData.data &&
                    documentRequestDocReduxListData.data.data.length === 0 ? (
                      <div
                        className="p-5 col-md-12"
                        style={{ textAlign: "center" }}
                      >
                        <p style={{ color: "red" }}>
                          There is no Requested Document Found Yet
                        </p>
                      </div>
                    ) : (
                      ""
                    )}
                  </Row>
                </div>
                <Drawer
                  placement="right"
                  visible={open}
                  title={commentData?.docName}
                  onClose={onClose}
                >
                  <Container className="p-0">
                    <div className="comment-box">
                      <div className="document-details">
                        <span className="comment-id d-block text-primary font-weight-semibold">
                          #93457
                        </span>
                        <span className="text-muted d-block font-weight-semibold font-14">
                          {commentData?.givenDocName}
                        </span>
                        <span
                          className="date d-block font-weight-semibold font-14"
                          key={commentData?.index}
                        >
                          {moment(commentData?.createdAt).format("DD-MMM-YYYY")}
                        </span>
                        <span className="time d-block">
                          {commentData &&
                            commentData.updatedAt &&
                            moment.utc(commentData.updatedAt).format("HH:mm A")}
                        </span>
                      </div>

                      <div className="doc-img">
                        {/* <Image src={editedImage ? editedImage : commentmodel} /> */}
                        {docPreviewData.urlType === "pdf" && (
                          <object
                            data={docPreviewData.filePath}
                            type="application/pdf"
                          />
                        )}
                        {docPreviewData.urlType === "jpeg" && (
                          <Image
                            src={
                              discussionCommentId?.docPath &&
                              s3bucketUrl + discussionCommentId?.docPath
                                ? s3bucketUrl + discussionCommentId?.docPath
                                : commentmodel
                            }
                          />
                        )}
                        {docPreviewData.urlType === "jpg" && (
                          <Image
                            src={
                              discussionCommentId?.docPath &&
                              s3bucketUrl + discussionCommentId?.docPath
                                ? s3bucketUrl + discussionCommentId?.docPath
                                : commentmodel
                            }
                          />
                        )}
                        {docPreviewData.urlType === "png" && (
                          <Image
                            src={
                              discussionCommentId?.docPath &&
                              s3bucketUrl + discussionCommentId?.docPath
                                ? s3bucketUrl + discussionCommentId?.docPath
                                : commentmodel
                            }
                          />
                        )}
                      </div>
                      <div className="d-flex align-items-center">
                        <img
                          src={
                            commentData &&
                            commentData.sentBy &&
                            commentData.sentBy.photo
                          }
                          onError={addDefaultSrc}
                          className="me-2 rounded-circle shadow"
                          width="40"
                          height="40"
                        />
                        <div>
                          <span className="d-block font-14 font-weight-semibold">
                            {commentData &&
                              commentData.sentBy.firstName +
                                " " +
                                commentData.sentBy.lastName}
                          </span>{" "}
                          <span className="d-block font-14">
                            {commentData && commentData.sentBy.emailId}
                          </span>
                        </div>
                      </div>
                      <div className="text-sec">
                        <div className="comment-body-scroll">
                          {discussionCommentList &&
                            discussionCommentList
                              .map((item, index) => {
                                return (
                                  <div className="comment-box d-flex justify-content-between w-100 mt-3">
                                    <div
                                      className="comment-content d-flex align-items-center"
                                      key={index}
                                    >
                                      <img
                                        src={profileavtar}
                                        className="me-2 rounded-circle align-self-start"
                                        width="40"
                                        height="40"
                                      />
                                      <div className="d-block align-self-center">
                                        {/* <p>Darlene Robertson</p> */}
                                        <span className="d-block font-weight-semibold">
                                          {item && item?.msgBy
                                            ? item?.msgBy?.firstName +
                                              " " +
                                              item?.msgBy?.lastName
                                            : offerProfileData.firstName +
                                              " " +
                                              offerProfileData.lastName}
                                          {item && !item.msgBy ? (
                                            <Badge
                                              variant="warning"
                                              className="ms-1"
                                            >
                                              You
                                            </Badge>
                                          ) : JSON.parse(getItem("User"))
                                              ._id === item.msgBy._id ? (
                                            <Badge
                                              variant="success"
                                              className="ms-1"
                                            >
                                              Candidate
                                            </Badge>
                                          ) : (
                                            <Badge
                                              variant="primary"
                                              className="ms-1"
                                            >
                                              IndiaNIC
                                            </Badge>
                                          )}
                                        </span>
                                        <span className="d-block font-12">
                                          {item && item?.msg}
                                        </span>
                                      </div>
                                    </div>
                                    <span className="text-right fw-semibold font-12 flex-shrink-0">
                                      {moment
                                        .utc(item.createdAt)
                                        .local()
                                        .startOf("seconds")
                                        .fromNow()}
                                    </span>
                                  </div>
                                );
                              })
                              .reverse()}
                        </div>
                      </div>
                      <Form className="add-comment-textbox">
                        <Form.Group
                          controlId="formBasicComment"
                          className="mb-2"
                        >
                          <Form.Label>Add Comment</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            className={
                              errors.comment ? "form-control error-red" : ""
                            }
                            value={docummentComment}
                            onChange={(e) => {
                              errors = Object.assign(errors, {
                                comment: "",
                              });
                              setErrors(errors);
                              setDocummentComment(e.target.value);
                            }}
                          />
                          <small className="error-msg" style={{ color: "red" }}>
                            {errors.comment}
                          </small>
                        </Form.Group>
                        <div className="d-flex justify-content-end">
                          <Button
                            variant="primary"
                            className="rounded-pill px-4"
                            type="submit"
                            onClick={(e) => addComment(e)}
                          >
                            Send
                          </Button>
                        </div>
                      </Form>
                    </div>
                  </Container>
                </Drawer>
                <Modal
                  show={show}
                  onHide={handleClose}
                  className="comment-modal"
                >
                  <Modal.Body>
                    <button
                      class="d-inline-block ms-auto close-btn bx bx-x btn float-right p-0"
                      onClick={handleClose}
                    ></button>
                    <Container className="p-0">
                      <Row>
                        <Col sm={12} lg={6}>
                          <div className="doc-img mb-md-4 mb-4 mb-lg-0">
                            {docPreviewData.urlType === "pdf" && (
                              <object
                                data={docPreviewData.filePath}
                                type="application/pdf"
                              />
                            )}
                            {docPreviewData.urlType === "jpeg" && (
                              <Image
                                src={
                                  discussionCommentId?.docPath &&
                                  s3bucketUrl + discussionCommentId?.docPath
                                    ? s3bucketUrl + discussionCommentId?.docPath
                                    : commentmodel
                                }
                              />
                            )}
                            {docPreviewData.urlType === "jpg" && (
                              <Image
                                src={
                                  discussionCommentId?.docPath &&
                                  s3bucketUrl + discussionCommentId?.docPath
                                    ? s3bucketUrl + discussionCommentId?.docPath
                                    : commentmodel
                                }
                              />
                            )}
                            {docPreviewData.urlType === "png" && (
                              <Image
                                src={
                                  discussionCommentId?.docPath &&
                                  s3bucketUrl + discussionCommentId?.docPath
                                    ? s3bucketUrl + discussionCommentId?.docPath
                                    : commentmodel
                                }
                              />
                            )}
                          </div>
                        </Col>
                        <Col sm={12} lg={6}>
                          <div className="text-sec">
                            <div className="document-details">
                              <span className="comment-id d-inline-block">
                                #93457
                              </span>
                              <Card.Title>{commentData?.docName}</Card.Title>
                              <small className="text-muted">
                                {commentData?.givenDocName}
                              </small>
                              <div className="d-flex justify-content-between">
                                <div>
                                  <p className="date" key={commentData?.index}>
                                    {moment(commentData?.createdAt).format(
                                      "DD-MMM-YYYY"
                                    )}
                                  </p>
                                  <small className="time">
                                    {commentData &&
                                      commentData.updatedAt &&
                                      moment
                                        .utc(commentData.updatedAt)
                                        .format("HH:mm A")}
                                  </small>
                                </div>
                                <div className="d-flex align-self-center">
                                  <img
                                    src={
                                      commentData &&
                                      commentData.sentBy &&
                                      commentData.sentBy.photo
                                    }
                                    onError={addDefaultSrc}
                                    className="me-2 rounded-circle shadow ms-2"
                                    width="40"
                                    height="40"
                                  />
                                  <div class="date">
                                    <p className="mb-1">
                                      {commentData &&
                                        commentData.sentBy.firstName +
                                          " " +
                                          commentData.sentBy.lastName}
                                    </p>{" "}
                                    <p className="time">
                                      {commentData &&
                                        commentData.sentBy.emailId}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="comment-body-scroll">
                              {discussionCommentList &&
                                discussionCommentList
                                  .map((item, index) => {
                                    return (
                                      <div className="comment-box d-flex">
                                        <div
                                          className="comment-content d-flex"
                                          key={index}
                                        >
                                          <img
                                            src={profileavtar}
                                            className="me-2 rounded-circle align-self-start"
                                            width="35"
                                            height="35"
                                          />
                                          <div className="d-block align-self-center">
                                            {/* <p>Darlene Robertson</p> */}
                                            <p>
                                              {item && item?.msgBy
                                                ? item?.msgBy?.firstName +
                                                  " " +
                                                  item?.msgBy?.lastName
                                                : offerProfileData.firstName +
                                                  " " +
                                                  offerProfileData.lastName}
                                              {item && !item.msgBy ? (
                                                <Badge
                                                  variant="warning"
                                                  className="ms-1"
                                                >
                                                  You
                                                </Badge>
                                              ) : JSON.parse(getItem("User"))
                                                  ._id === item.msgBy._id ? (
                                                <Badge
                                                  variant="success"
                                                  className="ms-1"
                                                >
                                                  Candidate
                                                </Badge>
                                              ) : (
                                                <Badge
                                                  variant="primary"
                                                  className="ms-1"
                                                >
                                                  IndiaNIC
                                                </Badge>
                                              )}
                                            </p>
                                            <p className="desc">
                                              {/*  Looks like the image is blurred please
                                        reupload */}
                                              {item && item?.msg}
                                            </p>
                                          </div>
                                        </div>
                                        <div className="duration">
                                          {/* <p className="text-right">12d ago</p> */}
                                          <p className="text-right">
                                            {moment
                                              .utc(item.createdAt)
                                              .local()
                                              .startOf("seconds")
                                              .fromNow()}
                                          </p>
                                        </div>
                                      </div>
                                    );
                                  })
                                  .reverse()}
                            </div>
                            <Form>
                              <Form.Group
                                controlId="formBasicComment"
                                className="mb-3"
                              >
                                <Form.Label>Add Comment</Form.Label>
                                <Form.Control
                                  as="textarea"
                                  rows={3}
                                  className={
                                    errors.comment
                                      ? "form-control error-red"
                                      : ""
                                  }
                                  value={docummentComment}
                                  onChange={(e) => {
                                    errors = Object.assign(errors, {
                                      comment: "",
                                    });
                                    setErrors(errors);
                                    setDocummentComment(e.target.value);
                                  }}
                                />
                                <small
                                  className="error-msg"
                                  style={{ color: "red" }}
                                >
                                  {errors.comment}
                                </small>
                              </Form.Group>
                              <Button
                                className="theme-btn w-25 float-right"
                                type="submit"
                                onClick={(e) => addComment(e)}
                              >
                                Send
                              </Button>
                            </Form>
                          </div>
                        </Col>
                      </Row>
                    </Container>
                  </Modal.Body>
                </Modal>
              </div>
            </div>
          </Container>
        </section>
      </MasterLayout>
    </>
  );
};
export default Documents;
